import React, { useEffect, useState, useRef } from 'react'
import  './css/product.css'
import { useUser } from '../Auth/UsersContext';
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { app, db } from '../Admin/Config/Config';
import { useNavigate } from 'react-router-dom';
import { getFunctions, httpsCallable } from "firebase/functions";
import LoadingTwo from '../Loading/LoadingTwo';
import { getAuth } from 'firebase/auth';
import { usePaymentSuccess } from '../Payment/PaymentStatusContext';

export default function Courses() {
  const { user,loading } = useUser();
  const { openPaymentSuccess } = usePaymentSuccess();
  const [tabLists, settabLists] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const functions = getFunctions(app, "asia-south1");
  const navigate = useNavigate();
  const tabs = ["All Courses","Purchased", "Featured", "Kids", "Spoken", "Vocabulary", "Grammar"];
  const [activeTab, setActiveTab] = useState(tabs[0]); 
  // ================== Fetch Courses ================== //
 const fetchCourses = (purchasedCourseIds) => {
   const coursesRef = collection(db, "jaffers_english_courses");
   const q =
     getAuth().currentUser.email === "athulramco3@gmail.com"
       ? query(
           coursesRef,
           //  where("status", "==", true),
           orderBy("order", "desc")
         )
       : query(
           coursesRef,
           where("status", "==", true),
           orderBy("order", "desc")
         );

   // Using onSnapshot for real-time updates
   const unsubscribe = onSnapshot(
     q,
     (snapshot) => {
       const all = snapshot.docs.map((doc) => ({
         id: doc.id,
         ...doc.data(),
         isPurchased: (purchasedCourseIds || []).includes(doc.id),
       }));
       const visibleCourses = all.filter(
         (course) => course.isPurchased || course.admission === true
       );
       setAllCourses(visibleCourses);
       settabLists(visibleCourses);
     },
     (error) => {
       console.error("Error fetching courses:", error);
     }
   );
   

   // Return unsubscribe function to clean up the listener when needed
   return unsubscribe;
 };

  useEffect(() => {
    if (!loading && user) {
      fetchCourses(user.je_courses || []);
    } else if (!loading) {
      fetchCourses();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading]);

   // ================== Handle Navigation ================== //
    const handleNavigation = (course) => {
      if (course.course_type === "normal") {
    navigate(
      `/view-course?id=${course.id}&fId=${false}`
    );
      } else if(course.course_type === "folder"){
          navigate(`/view-folder?id=${course.id}`);
      }
    };

    // ================== Handle Tab Click ================== //
    const handleTabClick = (tab) => {
      if (tab === "All Courses") {
        settabLists(
          allCourses.filter(
            (course) => course.isPurchased || course.admission === true
          )
        );
      } else if (tab === "Purchased") {
        if (user && user.je_courses) {
          settabLists(
            allCourses.filter((course) => user.je_courses.includes(course.id))
          );
        } else {
          settabLists([]);
        }
      } else {
        const categoryTabs = [
          "Featured",
          "Kids",
          "Spoken",
          "Vocabulary",
          "Grammar",
        ];
        if (categoryTabs.includes(tab)) {
          settabLists(
            allCourses.filter(
              (course) =>
                Array.isArray(course.video_category_array) &&
                course.video_category_array.includes(tab) &&
                (course.isPurchased || course.admission === true)
            )
          );
        }
      }

      setActiveTab(tab);
    };
    
    
    // ================== Handle Purchase ================== //
    const hanldePurchase = (event,course) => {
      setPurchaseLoading(true);
      event.stopPropagation();
     const payload = {
       study_stream: "Jaffers English",
       amount: parseFloat(course.offer_fee)*100,
       email: user?.email?? "",
       name: user?.name?? "",
       mobile: user?.mobile?? "",
       uid: user?.uid?? "",
       course_id: course.id,
       title: course.title,
       district: user?.district?? "",
       days: course.access_days,
       purchase_type: "course",
       platform: "web"
     };
     const paymentRequest = httpsCallable(functions, "createOrderId");
      paymentRequest({
        img: course.img_url,
        orderdetails: payload,
        amount: parseFloat(course.offer_fee)*100,
      }).then((result) => {
         const order = result.data;
         if (order && order !== 404) {
           const options = {
             key: process.env.REACT_APP_RAZOR_KEY,
             amount: order.amount,
             currency: order.currency,
             name: "Jaffer's English",
             description: "Jaffer's English Course",
             image: course.img_url,
             order_id: order.id,
             method: {
               netbanking: true,
               card: true,
               upi: false, // 👈 this disables UPI in the Checkout form
               wallet: true,
             },
             handler: function (response) {
              openPaymentSuccess({
                status: "success",
                orderId: order.id,
                paymentId: response.razorpay_payment_id||"",
                courseTitle: course.title,
                amount: course.offer_fee,
              });
             },
             prefill: {
               name: order.notes.user_name,
               email: user.email,
               contact: user.mobile,
             },
             notes: {
               address: "Razorpay Corporate Office",
             },
             theme: {
               color: "#3399cc",
             },
             modal: {
               ondismiss: function () {
                 // setloading(false);
               },
             },
           };

          try {
            const rzp1 = new window.Razorpay(options);
            rzp1.open();
            setPurchaseLoading(false);
            rzp1.on("payment.failed", function (response) {
              openPaymentSuccess({
                status: "failed",
                orderId: order.id||"",
                paymentId: response.razorpay_payment_id||"",
                courseTitle: course.title||"",
                amount: course.offer_fee||"",
                message: response.error.code||"",
              });
            });
          } catch (error) {
            setPurchaseLoading(false);
            openPaymentSuccess({
              status: "failed",
              orderId: order.id||"",
              paymentId: "",
              courseTitle: course.title,
              amount: course.offer_fee,
              message: error.message
            })
            console.error("Razorpay Error:", error);
            alert("Payment initialization failed!");
          }
         }
      });
    }
      const [isLoading, setIsLoading] = useState(true);
      const [purchaseLoading, setPurchaseLoading] = useState(false);
      const [detailsCourse, setDetailsCourse] = useState(null);
      const [showModal, setShowModal] = useState(false);
      const dialogRef = useRef(null);
      const closeBtnRef = useRef(null);

      const openDetails = (e, course) => {
        e.stopPropagation();
        setDetailsCourse(course);
        // allow next tick before animating in
        requestAnimationFrame(() => setShowModal(true));
      };

      const closeDetails = () => {
        setShowModal(false);
        // wait for animation to finish before unmounting
        setTimeout(() => setDetailsCourse(null), 180);
      };

      // Close on ESC and lock background scroll when modal is open
      useEffect(() => {
        if (!detailsCourse) return;
        const onKeyDown = (ev) => {
          if (ev.key === 'Escape') {
            closeDetails();
          }
          if (ev.key === 'Tab' && dialogRef.current) {
            const selectors = 'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
            const focusables = Array.from(dialogRef.current.querySelectorAll(selectors)).filter(el => !el.hasAttribute('disabled'));
            if (focusables.length === 0) return;
            const first = focusables[0];
            const last = focusables[focusables.length - 1];
            if (ev.shiftKey) {
              if (document.activeElement === first) {
                last.focus();
                ev.preventDefault();
              }
            } else {
              if (document.activeElement === last) {
                first.focus();
                ev.preventDefault();
              }
            }
          }
        };
        document.addEventListener('keydown', onKeyDown);

        // Lock scroll and set initial focus
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        // focus close button after mount
        setTimeout(() => {
          try { closeBtnRef.current?.focus(); } catch (_) {}
        }, 0);

        return () => {
          document.removeEventListener('keydown', onKeyDown);
          document.body.style.overflow = previousOverflow;
        };
      }, [detailsCourse]);

      const handleLiveUrl = (event,course) => {
        if (course.isPurchased) {
          window.open(course?.live_url ?? "", "_blank");
        } else {
          hanldePurchase(event, course);
        }
      }
  
  return (
    <div className="px-3   py-4 min-h-screen ">
      <LoadingTwo toggle={purchaseLoading} />
      {allCourses && allCourses.length ? (
        <>
          <div className="flex gap-2 py-4  flex-wrap">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabClick(tab)}
                className={`px-6 ml-1  py-2 text-lg font-serif rounded-xl transition-all ${
                  activeTab === tab
                    ? "text-white font-base bg-emerald-700 shadow-md"
                    : "text-gray-900 bg-gray-200 hover:bg-gray-300"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="">
            <p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3  py-2">
                {tabLists &&
                  tabLists.map((course) => {
                    return (
                      <div
                        key={course.id}
                        onClick={(e) => {
                          course.isPurchased ?
                          handleNavigation(course):
                          openDetails(e, course);
                          }}
                        class="group relative bg-black rounded-xl border border-gray-700 overflow-hidden transition-all duration-300 hover:shadow-xl "
                      >
                        <div class=" aspect-video relative overflow-hidden">
                          <div className="relative w-full  ">
                            {isLoading && (
                              <div className="absolute inset-0 bg-gray-300 animate-shimmer"></div>
                            )}

                            <img
                              src={course.img_url}
                              alt="Course"
                              className="w-full   object-contain transition-transform duration-300 group-hover:scale-105"
                              onLoad={() => setIsLoading(false)}
                            />
                          </div>
                          {course.stream_mode === "live" ? (
                            <div class="absolute top-3 left-3 z-10">
                              <div class="flex items-center gap-1.5 bg-gradient-to-r from-red-600 to-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-sm">
                                <span class="relative flex h-2 w-2">
                                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                                  <span class="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                                </span>
                                LIVE
                              </div>
                            </div>
                          ) : (
                            <div class="absolute top-3 left-3 z-10">
                              <div class="flex items-center gap-1.5 bg-gradient-to-r from-blue-600 to-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-sm">
                                <span class="relative flex h-2 w-2">
                                  <span class="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                                </span>
                                RECORDED
                              </div>
                            </div>
                          )}

                          {course.is_live && (
                            <div class="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 p-4">
                              <div class="flex items-center justify-between">
                                <span class="text-sm font-medium text-gray-100">
                                  Live Session
                                </span>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleLiveUrl(e, course);
                                  }}
                                  class="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-700 hover:to-red-700 text-white rounded-md transition-all duration-200 text-sm font-semibold shadow-sm hover:shadow-md"
                                >
                                  <svg
                                    class="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={1}
                                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                    />
                                  </svg>
                                  Join Now
                                </button>
                              </div>
                            </div>
                          )}
                        </div>

                        <div class="course-details bg-black p-4">
                          <h2 class="text-md ml-2 text-left mt-2 font-semibold text-gray-100 mb-2 h-12">
                            {course.title.length > 50
                              ? course.title.slice(0, 80)
                              : course.title}
                          </h2>
                          <div class="ml-2 -mt-1">
                            <button
                              onClick={(e) => openDetails(e, course)}
                              class="text-emerald-400 hover:text-emerald-300 text-sm underline"
                            >
                              View Details
                            </button>
                          </div>

                          <div class="mt-4 ml-1 ">
                            {!course?.isPurchased ? (
                              <div class="flex justify-between items-center">
                                <div class="space-y-1">
                                  <div class="flex items-baseline gap-1">
                                    <span class="text-xl font-bold text-gray-100">
                                      ₹{course.offer_fee}
                                    </span>
                                    <span class="text-sm text-green-600 ml-2 line-through">
                                      ₹{course.actual_fee}
                                    </span>
                                  </div>
                                </div>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    course.isPurchased ? handleNavigation(course) : openDetails(e, course);
                                  }}
                                  class="px-4 py-2 bg-emerald-700  text-white rounded-lg text-sm font-semibold shadow-sm transition-all duration-200 transform hover:scale-[1.02]"
                                >
                                  Enroll Now
                                </button>
                              </div>
                            ) : (
                              <button
                                onClick={() => handleNavigation(course)}
                                className="w-full py-2 bg-gradient-to-r from-emerald-600 to-emerald-800 text-white rounded-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 hover:from-emerald-700 hover:to-emerald-900 shadow-lg"
                              >
                                Continue Learning
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </p>
          </div>
        </>
      ) : null}
      {detailsCourse && (
       <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
  <div
    className={`absolute inset-0 bg-transparent backdrop-blur-sm transition-opacity duration-300 ${
      showModal ? "opacity-100" : "opacity-0"
    }`}
    onClick={closeDetails}
  ></div>
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="course-details-title"
    aria-describedby="course-details-desc"
    ref={dialogRef}
    className={`relative w-full max-w-lg mx-auto bg-white rounded-xl shadow-2xl ring-1 ring-slate-200/50 overflow-hidden transform transition-all duration-300 ease-out ${
      showModal
        ? "opacity-100 scale-100 translate-y-0"
        : "opacity-0 scale-95 translate-y-4"
    } flex flex-col max-h-[90vh]`}
  >
    {/* Header */}
    <div className="bg-emerald-700  text-white px-6 py-5 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <svg
          className="w-5 h-5 text-slate-300"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25A8.966 8.966 0 0118 3.75c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0118 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
          />
        </svg>
        <h3
          id="course-details-title"
          className="text-xl font-medium tracking-tight"
        >
          Course Overview
        </h3>
      </div>
      <button
        onClick={closeDetails}
        aria-label="Close"
        ref={closeBtnRef}
        className="inline-flex h-9 w-9 items-center justify-center rounded-lg hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 transition-colors duration-200"
      >
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    {/* Content */}
    <div className="flex-1 overflow-y-auto p-5">
      <div className="space-y-6">
        {/* Course Image */}
        {detailsCourse.img_url && (
          <div className="relative w-full h-56 bg-slate-50 rounded-lg overflow-hidden ring-1 ring-slate-200/60 shadow-sm">
            <img
              src={detailsCourse.img_url}
              alt="Course"
              className="absolute inset-0 h-full w-full object-fit"
            />
          </div>
        )}

        {/* Course Info */}
        <div className="space-y-4">
          <h4 className="text-slate-900 text-xl font-semibold leading-tight">
            {detailsCourse.title}
          </h4>
          
          {detailsCourse.desc && (
            <p
              id="course-details-desc"
              className="text-slate-600 text-sm leading-relaxed whitespace-pre-line"
            >
              {detailsCourse.desc && detailsCourse.desc.trim().length > 0
                ? detailsCourse.desc
                : "No description available for this course."}
            </p>
          )}

          {/* Course Stats */}
          <div className="flex flex-wrap items-center gap-2 pt-1">
            {detailsCourse.chapter_count && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-blue-50 text-blue-700 text-xs font-medium border border-blue-100">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25A8.966 8.966 0 0118 3.75c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0118 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                </svg>
                {detailsCourse.chapter_count} Chapters
              </span>
            )}
            
            {detailsCourse.video_count && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-purple-50 text-purple-700 text-xs font-medium border border-purple-100">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
                </svg>
                {detailsCourse.video_count} Videos
              </span>
            )}

            {detailsCourse.stream_mode === "live" && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-red-50 text-red-700 text-xs font-medium border border-red-100">
                <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div>
                Live Course
              </span>
            )}

            {detailsCourse.access_days && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-emerald-50 text-emerald-700 text-xs font-medium border border-emerald-100">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {detailsCourse.access_days} Days Access
              </span>
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Footer */}
    <div className="px-6 py-5 bg-slate-50/50 border-t border-slate-200/60">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Pricing */}
        {!detailsCourse.isPurchased && (
          <div className="flex items-baseline gap-3">
            {typeof detailsCourse.offer_fee !== "undefined" && (
              <span className="text-2xl font-bold text-slate-900">
                ₹{detailsCourse.offer_fee}
              </span>
            )}
            {detailsCourse.actual_fee && (
              <span className="text-sm text-slate-500 line-through">
                ₹{detailsCourse.actual_fee}
              </span>
            )}
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:ml-auto">
          {!detailsCourse?.isPurchased ? (
            <>
              <button
                disabled={purchaseLoading}
                onClick={(e) => {
                  handleNavigation(detailsCourse);
                }}
                className="inline-flex items-center justify-center px-4 py-2.5 border border-slate-300 bg-white text-slate-700 rounded-lg text-sm font-medium shadow-sm hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500/50 transition-colors duration-200"
              >
                View Course Contents
              </button>
              <button
                disabled={purchaseLoading}
                onClick={(e) => {
                  e.stopPropagation();
                  hanldePurchase(e, detailsCourse);
                }}
                className="inline-flex items-center justify-center px-5 py-2.5 bg-green-700 text-white rounded-lg text-sm font-semibold shadow-sm hover:bg-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 transition-colors duration-200 disabled:opacity-50"
              >
                {purchaseLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing...
                  </>
                ) : (
                  "Buy Now"
                )}
              </button>
            </>
          ) : (
            <button
              onClick={() => {
                closeDetails();
                handleNavigation(detailsCourse);
              }}
              className="inline-flex items-center justify-center px-6 py-2.5 bg-slate-900 text-white rounded-lg text-sm font-semibold shadow-sm hover:bg-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 transition-colors duration-200"
            >
              Continue Learning
              <svg className="ml-2 w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
</div>
      )}
    </div>
  );
}
